"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeChatStepOutputDtoSchema = exports.executeChatStepInputDtoSchema = void 0;
const zod_1 = require("zod");
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
exports.executeChatStepInputDtoSchema = zod_1.z.object({
    userMessageText: zod_1.z.string(),
    base64ImageAttachments: zod_1.z.array(zod_1.z.string()).optional(),
    jsonSchema: zod_1.z.record(zod_1.z.string(), zod_1.z.any()).optional(),
    systemPrompt: zod_1.z.string().optional(),
    messageHistory: zod_1.z
        .array(zod_1.z.object({
        role: zod_1.z.string(),
        content: zod_1.z.string(),
    }))
        .optional(),
    modelConfig: cadstrom_shared_1.AiModelConfigSchema.extend({
        temperature: zod_1.z.number().min(0).max(1).optional(),
    })
        .strict()
        .optional(),
    fileAttachments: zod_1.z
        .array(zod_1.z.object({
        fileId: zod_1.z.string(),
        pageLabels: zod_1.z.array(zod_1.z.nativeEnum(sigma_engine_shared_1.DatasheetContentLabelIds)).optional(),
    }))
        .optional(),
    toolNames: zod_1.z.array(zod_1.z.string()).optional(),
});
exports.executeChatStepOutputDtoSchema = zod_1.z.object({
    response: zod_1.z.string(),
    updatedMessageHistory: zod_1.z.array(zod_1.z.object({
        role: zod_1.z.string(),
        content: zod_1.z.string(),
    })),
    traceUrl: zod_1.z.string().url().optional(),
});
//# sourceMappingURL=execute-chat-step.dto.js.map